'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var FundManagersCard = function (_React$Component) {
  _inherits(FundManagersCard, _React$Component);

  function FundManagersCard(props) {
    _classCallCheck(this, FundManagersCard);

    var _this = _possibleConstructorReturn(this, (FundManagersCard.__proto__ || Object.getPrototypeOf(FundManagersCard)).call(this, props));

    _this.getInvestmentAdvisorClass = function () {
      return _this.props.headerTitleID === "investmentAdvisorsCardHeaderId" ? (0, _functional_utility.ifMobileBreakpoint)(_this.props.breakpoint, "height-50", "vertical-align-top") : "";
    };

    return _this;
  }

  _createClass(FundManagersCard, [{
    key: 'getYearsString',
    value: function getYearsString(numberOfYearsInFloat) {
      if (numberOfYearsInFloat >= 0 && numberOfYearsInFloat < 1) {
        return this.props.intl.formatMessage({
          id: "pdp-fund-manager-less-than-one-year",
          defaultMessage: "Less than one year"
        });
      }

      var numberOfYears = Math.floor(numberOfYearsInFloat);
      if (numberOfYears > 1) {
        return this.props.intl.formatMessage({
          id: "years",
          defaultMessage: numberOfYears + " years"
        }, { NUMBER: numberOfYears });
      } else if (numberOfYears === 1) {
        return this.props.intl.formatMessage({
          id: "year",
          defaultMessage: numberOfYears + " year"
        }, { NUMBER: numberOfYears });
      } else {
        return "-";
      }
    }
  }, {
    key: 'renderFundManagerImage',
    value: function renderFundManagerImage(fundManager) {
      var imageURL = this.getImageURL(fundManager);
      return _react2.default.createElement(
        'div',
        {
          className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "margin-right-0 col-xs-2 col-sm-2", "margin-vertical-0 display-inline-block  position-absolute top-position") + ' ' },
        !(0, _ramda.isNil)(imageURL) && _react2.default.createElement('img', {
          className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "height-34 width-34", "height-50 width-50") + ' border-radius-50 fund-managers-img',
          src: imageURL, 'data-testid': 'fund-manager-image',
          alt: '' })
      );
    }
  }, {
    key: 'getImageURL',
    value: function getImageURL(fundManager) {
      var imageURL = null;
      if (!this.props.hideShadowImage) {
        imageURL = this.props.gaiaRedirectUrl + "/images/default-user-image.svg";
      }
      if (fundManager.imageURL) {
        imageURL = fundManager.imageURL;
      }
      return imageURL;
    }
  }, {
    key: 'portfolioManagerLabelIsSet',
    value: function portfolioManagerLabelIsSet() {
      return _jquery2.default.trim((0, _jquery2.default)('#fund-manager-pos').text()) !== "";
    }
  }, {
    key: 'renderFundManagerNameLink',
    value: function renderFundManagerNameLink(fundManager) {
      if (!(0, _functional_utility.isNilOrEmpty)(fundManager.profileURL) && !this.props.hideFundManagerBioLinks) {
        return _react2.default.createElement(
          'a',
          { href: fundManager.profileURL,
            'data-testid': 'fund-manager-profile-link' },
          this.getFullName(fundManager)
        );
      } else {
        return _react2.default.createElement(
          'span',
          null,
          this.getFullName(fundManager)
        );
      }
    }
  }, {
    key: 'renderFundManagers',
    value: function renderFundManagers(fundManagers) {
      var _this2 = this;

      var mobileBreakpointClassName = (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "col-xs-4 col-sm-4 padding-top-5", "width-percent-33");
      var fundManagerDiv = null;
      var isAdvisorWithoutShowingManagingYears = this.props.headerTitleID === "investmentAdvisorsCardHeaderId" && (0, _ramda.includes)("FUND_ADVISORS_WITHOUT_FUND_EXPERIENCE", this.props.formattingRules);
      if (isAdvisorWithoutShowingManagingYears || (0, _ramda.includes)("FUND_MANAGERS_WITHOUT_FUND_EXPERIENCE", this.props.formattingRules)) {
        fundManagerDiv = mapIndexed(function (fundManager, i) {
          return _this2.renderFundManagersWithoutFundExp(i, fundManager);
        }, fundManagers);
        if (fundManagers[0].industryExperience === 0 && fundManagers[0].jpmcExperience === 0) {
          fundManagerDiv = _react2.default.createElement(
            'div',
            { className: 'col-xs-12 col-sm-12 col-md-10 col-lg-12 col-xlg-12' },
            fundManagerDiv
          );
        }
      } else {
        fundManagerDiv = mapIndexed(function (fundManager, i) {
          return _this2.renderFundManagersWithFundExp(i, fundManager, mobileBreakpointClassName, fundManagers.length);
        }, fundManagers);
      }

      return fundManagerDiv;
    }
  }, {
    key: 'renderManagerOrganisation',
    value: function renderManagerOrganisation(fundManager) {
      if (fundManager.jpmcExperience >= 0) {
        if (!(0, _functional_utility.isNilOrEmpty)(fundManager.fundSubAdvisor)) {
          return _string_utility2.default.renderFormattedLabel("With " + fundManager.fundSubAdvisor, "pdp-fund-manager-with", { fundSubAdvisor: fundManager.fundSubAdvisor });
        }
        return _string_utility2.default.renderFormattedLabel("With J.P. Morgan", "pdp-fund-manager-with-jp-morgan");
      }
      return " ";
    }
  }, {
    key: 'renderFundManagersWithFundExp',
    value: function renderFundManagersWithFundExp(i, fundManager, mobileBreakpointClassName, length) {
      var expPostfixClass = (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "disclaimer", "body2");
      var expYrClass = (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "tag");
      return _react2.default.createElement(
        'div',
        { key: i, className: 'fund-managers-div' },
        _react2.default.createElement(
          'div',
          { className: 'row margin-horizontal-0 margin-top-20' },
          _react2.default.createElement(
            'div',
            {
              className: this.getInvestmentAdvisorClass() + ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "", "width-percent-33 display-inline-block position-relative"), 'data-pmid': '' + fundManager.identifier },
            this.renderFundManagerImage(fundManager),
            _react2.default.createElement(
              'div',
              {
                className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "margin-left-0 col-xs-10 col-sm-10 padding-left-5", "padding-left-65 display-inline-block") },
              _react2.default.createElement(
                'div',
                { className: '' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "sub-header-3", "tag"),
                  'data-testid': 'fund-manager', id: 'fund-manager-' + i },
                this.renderFundManagerNameLink(fundManager)
              ),
              !this.props.hidePosition && _react2.default.createElement(
                'div',
                { className: '' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "", "body2"), 'data-testid': 'fund-manager-position',
                  id: 'fund-manager-pos' },
                ' ',
                _string_utility2.default.renderFormattedLabel("Portfolio Manager", "pdp-overview-fundmanager-position-subheader-label", { role: this.props.role, defaultMsg: ' ' })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, (this.portfolioManagerLabelIsSet() || this.props.hideShadowImage && (0, _ramda.isNil)(this.getImageURL(fundManager)) ? "col-xs-push-2 col-sm-push-2 " : "") + "col-xs-10 col-sm-10 margin-left-0 padding-left-5", "float-right display-inline-block width-percent-63 position-relative") + ' ' },
            _react2.default.createElement(
              'div',
              { className: ' ' + mobileBreakpointClassName + ' display-inline-block vertical-align-top' },
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-manager-industry-exp', className: '' + expYrClass },
                this.getYearsString(fundManager.industryExperience)
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-manager-industry-exp-postfix',
                  className: '' + expPostfixClass },
                fundManager.industryExperience >= 0 ? _string_utility2.default.renderFormattedLabel("In the industry", "pdp-fund-manager-in-the-industry") : " "
              )
            ),
            _react2.default.createElement(
              'div',
              { className: mobileBreakpointClassName + ' display-inline-block padding-right-5 vertical-align-top' },
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-manager-jpmc-exp',
                  className: '' + expYrClass },
                this.getYearsString(fundManager.jpmcExperience)
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-manager-jpmc-exp-postfix',
                  className: '' + expPostfixClass },
                this.renderManagerOrganisation(fundManager)
              )
            ),
            _react2.default.createElement(
              'div',
              { className: mobileBreakpointClassName + ' display-inline-block vertical-align-top' },
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-manager-managing-exp',
                  className: '' + expYrClass },
                this.getYearsString(fundManager.fundManagingExperience)
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-manager-managing-exp-postfix',
                  className: '' + expPostfixClass },
                fundManager.fundManagingExperience >= 0 ? _string_utility2.default.renderFormattedLabel("Managing this fund", "pdp-fund-manager-managing-this-fund") : " "
              )
            )
          )
        ),
        this.shouldAddDividerLine(i, length)
      );
    }
  }, {
    key: 'shouldAddDividerLine',
    value: function shouldAddDividerLine(i, length) {
      if (i === length - 1) {
        return "";
      } else {
        return _react2.default.createElement('div', { className: 'top-divider' });
      }
    }
  }, {
    key: 'getFullName',
    value: function getFullName(fundManager) {
      if (!(0, _ramda.isNil)(fundManager.fullName)) {
        return fundManager.fullName;
      }
      return fundManager.firstName + " " + fundManager.lastName;
    }
  }, {
    key: 'render',
    value: function render() {
      if ((0, _ramda.isNil)(this.props.fundManagers)) {
        return null;
      }

      return _react2.default.createElement(
        _card_component2.default,
        {
          headerTitle: _string_utility2.default.renderFormattedLabel(this.props.title, this.props.titleID, { role: this.props.role }),
          headerTitleId: this.props.headerTitleID,
          headerTitleLabel: "",
          breakpoint: this.props.breakpoint,
          headerLabel: "",
          testId: this.props.testId,
          disclosureText: (0, _ramda.pathOr)(null, ["disclosures", this.props.disclosureId], this.props),
          placementId: this.props.disclosureId,
          dataTest: this.props.testId
        },
        this.renderFundManagers(this.props.fundManagers)
      );
    }
  }, {
    key: 'renderFundManagersWithoutFundExp',
    value: function renderFundManagersWithoutFundExp(i, fundManager) {
      var isCIFMFund = this.props.isCIFMFund;
      var fundManagerClassName = isCIFMFund ? "col-xs-6 col-sm-6 col-md-5 col-lg-6 col-xlg-6 " : "fund-managers-div";
      var widthPercentage = this.props.breakpoint === 4 && this.props.country === 'tw' ? 66 : 50;
      var otherPercentage = (100 - widthPercentage) / 2;
      var nameColumnWidthPercentage = isCIFMFund ? "" : "width-percent-" + widthPercentage;

      var mobileBreakpointClassName = (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "col-xs-12 col-sm-12 padding-top-5", "width-percent-100  padding-right-10");

      var yearsExpStyle = this.props.breakpoint > 2 ? {
        display: 'flex',
        alignItems: 'center',
        top: -4
      } : {};

      var yearsExpClass = this.props.breakpoint > 2 ? 'height-35' : '';

      var industryExpStyle = this.props.breakpoint > 2 ? {
        display: 'flex',
        alignItems: 'center'
      } : {};

      var industryExpClass = this.props.breakpoint > 2 ? 'height-22' : '';
      var expPostfixClass = (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "disclaimer", "body2");
      var expYrClass = (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "body2", "tag");
      var hideFundManagerPosition = this.props.hidePosition || this.props.isSMA && (0, _ramda.isNil)(fundManager.firstName) && (0, _ramda.isNil)(fundManager.lastName) && !(0, _ramda.isNil)(fundManager.fullName);
      return _react2.default.createElement(
        'div',
        { key: i, className: fundManagerClassName },
        _react2.default.createElement(
          'div',
          { className: 'row margin-horizontal-0 margin-top-10 margin-bottom-15' },
          _react2.default.createElement(
            'div',
            {
              className: this.getInvestmentAdvisorClass() + ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "", nameColumnWidthPercentage + " display-inline-block position-relative"), 'data-pmid': '' + fundManager.identifier },
            this.renderFundManagerImage(fundManager),
            _react2.default.createElement(
              'div',
              {
                className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "margin-left-0 col-xs-10 col-sm-10 " + (isCIFMFund ? "padding-left-25" : "padding-left-5"), "padding-left-65 display-inline-block") },
              _react2.default.createElement(
                'div',
                { className: yearsExpClass + ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "sub-header-3", "tag"), style: yearsExpStyle,
                  'data-testid': 'fund-manager-' + i, id: 'fund-manager-' + i },
                this.renderFundManagerNameLink(fundManager)
              ),
              !hideFundManagerPosition && _react2.default.createElement(
                'div',
                { className: industryExpClass + ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "", "body2"),
                  'data-testid': 'fund-manager-position',
                  style: industryExpStyle,
                  id: 'fund-manager-pos' },
                ' ',
                _string_utility2.default.renderFormattedLabel("Portfolio Manager", isCIFMFund ? "pdp-overview-cifm-fundmanager-position-subheader-label" : "pdp-overview-fundmanager-position-subheader-label", { role: this.props.role })
              )
            )
          ),
          !isCIFMFund && _react2.default.createElement(
            'div',
            {
              className: '' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, (this.portfolioManagerLabelIsSet() ? "col-xs-push-2 col-sm-push-2 " : "") + "col-xs-5 col-sm-5 margin-left-0 padding-left-5", "display-inline-block width-percent-" + otherPercentage + " position-relative") },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-manager-industry-exp',
                className: mobileBreakpointClassName + ' ' + yearsExpClass + ' ' + expYrClass + ' display-inline-block padding-left-0 position-relative',
                style: yearsExpStyle },
              this.getYearsString(fundManager.industryExperience)
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-manager-industry-exp-postfix',
                className: mobileBreakpointClassName + ' ' + industryExpClass + ' ' + expPostfixClass + ' padding-left-0',
                style: industryExpStyle },
              fundManager.industryExperience >= 0 ? _string_utility2.default.getLocalizedString(this.props.intl, "In the industry", "pdp-fund-manager-in-the-industry") : " "
            )
          ),
          !isCIFMFund && _react2.default.createElement(
            'div',
            {
              className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, (this.portfolioManagerLabelIsSet() ? "col-xs-push-2 col-sm-push-2 " : "") + "col-xs-5 col-sm-5 margin-left-0 padding-left-5", "display-inline-block width-percent-" + otherPercentage + " position-relative") },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-manager-jpmc-exp',
                className: mobileBreakpointClassName + ' ' + yearsExpClass + ' ' + expYrClass + ' display-inline-block padding-left-0 position-relative',
                style: yearsExpStyle },
              this.getYearsString(fundManager.jpmcExperience)
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-manager-jpmc-exp-postfix',
                className: mobileBreakpointClassName + ' ' + industryExpClass + ' ' + expPostfixClass + ' padding-left-0',
                style: industryExpStyle },
              fundManager.jpmcExperience >= 0 ? _string_utility2.default.getLocalizedString(this.props.intl, "With J.P. Morgan", "pdp-fund-manager-with-jp-morgan") : " "
            )
          )
        )
      );
    }
  }]);

  return FundManagersCard;
}(_react2.default.Component);

exports.default = (0, _reactIntl.injectIntl)(FundManagersCard, { withRef: true });